import React, { useEffect} from 'react';
import './App.css';
import {
  Routes, Route,
} from 'react-router-dom';
import { Login } from './_login/Login';
import { ChevronUp } from 'react-bootstrap-icons';
import { Button, Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { AppDispatch } from './_store';
import { appBootstrap } from './_store/thunks/app.thunks';
import { PrivateRoute } from './components/PrivateRoute';
import ContactsPage from './pages/ContactsPage';
import NewsPage from './pages/NewsPage';
import AppHeader from './pages_components/app/AppHeader';
import AdminPage from './pages/AdminPage';
import MainPage from './pages/MainPage';
import AppFooter from './pages_components/app/AppFooter';
import ProductPage from './pages/ProductPage';
import ProductsPage from './pages/ProductsPage';

function App() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(appBootstrap());
    window.addEventListener('scroll', scrollFunction);
    return () => {
      window.removeEventListener('scroll', scrollFunction);
    }
  }, []);

  return (
    <div>
      <AppHeader></AppHeader>

      <Container fluid className='body-container-fluid'>
        <Container className="body-container">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<MainPage />} />
            <Route path="/Products/:categoryId" element={<ProductsPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/admin" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
            <Route path="/Product/:id" element={<ProductPage />} />
          </Routes>
        </Container>

        <Button
          className="btn"
          id="btn-back-to-top">
          <ChevronUp type='bold' id='arrowTop' />
        </Button>
      </Container>

      <AppFooter></AppFooter>
    </div>
  );

  function scrollFunction() {
    let mybutton = document.getElementById("btn-back-to-top");

    if (mybutton) {
      mybutton.addEventListener("click", backToTop);

      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
  }

  function backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}

export default App;
